

import styled from 'styled-components';
import {
  IconStatusInformation,
  IconStatusPositive,
  IconStatusNegative,
  IconStatusWarning,
  IconStatusDefault,
  SimpleTableData,
  SimpleTableWrapper,
  Checkbox,
  IconArrowUpward,
  IconArrowDownward,
  SimpleTableHeader,
  DateRangePickerChips,
  MultiSelectChip,
  Loader,
  IconCheckCircle,
  PageHeaderTitle,
  Menu,
  SimpleTable,
  SimpleTableContainer,

  SimpleTableRow,
  SimpleTableTitle,

  focusOutlinesStyles,

  IconChevronLeft,
  Button,
  PageHeaderWrapper,
  Heading
} from 'cdk-radial';
import { FloatProps } from '../../common/types';


export const StyledTableFooter = styled.div`
  position: sticky;
  bottom: 300 !important;
  right: 0;
  border-top: 1px solid #dcddde;
  justify-content: flex-end;
  display: flex;
  height: 2.25rem;
  background-color: rgb(255, 255, 255);
  align-items: center;
  padding: 0.375rem 0.5rem;
`;

export const StyledIconStatusPositive = styled(IconStatusPositive)`
  fill: #09ad00;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;

export const StyledIconCheckCircle = styled(IconCheckCircle)`
  fill: #09ad00;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;

export const StyledIconStatusWarning = styled(IconStatusWarning)`
  fill: #fa9c19;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;
export const StyledIconStatusInformation = styled(IconStatusInformation)`
  fill: #074faf;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;

export const StyledIconInactiveInformation = styled(IconStatusNegative)`
  fill: gray;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;

export const StyledIconStatusNegative = styled(IconStatusNegative)`
  fill: #eb0000;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;
export const StyledIconStatusDefault = styled(IconStatusDefault)`
  fill: #8a8d92;
  height: 14px;
  width: 14px;
  padding-top: 3px;
`;

export const StyledIndicatorLabel = styled.div`
  padding-left: 3px;
`;

type InputWrapperType = {
  width?: string;
};

export const StyledSimpleTableData = styled(SimpleTableData) <InputWrapperType>`
  /* font-size: 14px;
  font-weight: 400; */
  /* padding-top: 0px;
  padding-bottom: 0px; */
  /* word-wrap: break-word;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width : ${(props: InputWrapperType) => props.width ?? ''}
  max-width : ${(props: InputWrapperType) => props.width ?? ''} */
`;

export const StyledSimpleTableWrapper = styled(SimpleTableWrapper)`
  border: none;
`;
export const StyledCheckboxLabel = styled.div`
  padding-top: 7px;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 24px;
  text-align: center;
  font-family: Roboto;
`;

export const StyledFilterCheckbox = styled(Checkbox)`
  padding-right: 0rem;
`;

type ArrowProps = { active: boolean };

export const StyledSortIndicatorWrapper = styled.div`
  width: fit-content;
  cursor: pointer;
  margin: 4px 2px 0 2px;
  float: ${(props: FloatProps) => props.float || 'left'};
`;

export const StyledUpArrow = styled(IconArrowUpward)`
  opacity: ${(props: ArrowProps) => (props.active ? '100' : '40')}%;
`;

export const StyledDownArrow = styled(IconArrowDownward)`
  opacity: ${(props: ArrowProps) => (props.active ? '100' : '40')}%;
`;

export const StyledColumnHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  float: ${(props: FloatProps) => props.float || 'left'};
`;

export const SharedStyledColumnHeader = styled(SimpleTableHeader)`
  border: inherit;
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
`;

export const FilterDateRangePickerChips = styled(DateRangePickerChips)`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-right: 6px;
  height: 32px;
  margin-top:8px;
  .DayPicker {
    z-index: 21;
  }
`;
type DropdownHeight = { maxHeight: string };
export const FilterMultiSelectChip = styled(MultiSelectChip)`
  padding: 6px;
  align-items: center;
  gap: 4px;
  z-index: 21;
  overflow-y: none;
  padding-right: 6px;
   max-height: ${(props: DropdownHeight) =>
    props.maxHeight ? props.maxHeight : ''};   
  max-width: 19rem;
`;
export const ChipDivider = styled.div`
  width: 5px;
`;
export const GridRowLoader = styled(Loader)`
  padding: 0.5rem;
`;

export const GridLoaderWrapper = styled.div`
  padding: 0px 10px;
`;

export const StyledEmptyMenu = styled.div`
  padding: 1rem;
`;



export const StyledPageHeaderTitle = styled(PageHeaderTitle)`
  padding: 0.2rem;
`;

export const StyledPageHeaderTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 60px;
`;
export const HeaderTitleContainer = styled.div`
  display: flex; 
  justify-content: center; 
  align-items: center;
`;
export const IconContainer = styled.div`
  display: flex;
`;

export const StyledAddInvoiceMenu = styled(Menu)`
  button.add-invoice-menu-options {
    background-color: white;

    :hover {
      background-color: rgba(236, 236, 236, 0.92);
    }
  }
`;

export const StyledHeaderButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 40% auto;
  gap: 1em;
`;

export const StyledSearch = styled.div`
  width: 364px;
  height: 32px;
  display: flex;
  padding: 1px 6px;
  gap: 4px;
`;

export const StyledH5 = styled.h5`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
`;


export const StickySimpleTable = styled(SimpleTable)`
  position: relative;
  overflow: auto;
  font-family: 'Roboto';
`;

export const StickySimpleTableHeader = styled(SimpleTableHeader) <{
  textAlign: string;
  width?: string;
}>`
  position: sticky;
  top: 0;
  font-size: 12px;
  line-height: 14px;
  th {
    box-shadow: none;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  padding-left: ${props => (props.textAlign === 'left' ? `0rem` : `0.5rem`)};
  padding-right: ${props => (props.textAlign === 'right' ? `0rem` : `0.5rem`)};
  text-align: ${props =>
    props.textAlign === 'right' ? `-webkit-right` : `-webkit-left`};
  width: ${(props: InputWrapperType) => props.width ?? ''};
  max-width: ${(props: InputWrapperType) => props.width ?? ''};
`;


export const StickySimpleTableContainer: any = styled(SimpleTableContainer)`
  max-width: '400px';
  overflow: auto;
  margin: '8px';
  min-height: '150px';
  height: '150px'
`;

export const ZebraSimpleTableRow = styled(SimpleTableRow)`
  :nth-child(even) {
    background-color: #151b2503;
    border-top: 1px solid #dcddde;
    :hover {
      background-color: ${({ theme }) =>
    theme.color.zebraStripe.hover.value as string};
    }
  }
  &:last-child {
    border-bottom: none;
  }
  cursor: pointer;
`;

export const StyledSimpleTableTitle = styled(SimpleTableTitle)`
  font-size: 18px;
  line-height: 24px;
`;

export const StyledIndicatorContainer = styled.div`
  display: flex;
`;

export const StyledAddInvoiceCheckBox = styled(Checkbox)`
  padding-right: 0.8rem;
`;

export const StyledAddInvoiceHeaderCheckBox = styled.div`
  padding-top: 0.8rem;
`;

export const StyledIndicatorLabelContainer = styled.div`
  padding-top: 0.2rem;
`;

export const FullWidthTableData = styled.td`
  height: 50vh;
  width: 100%;
  text-align: center;
`;

export const StyledLoader = styled(Loader)`
  display: flex;
`;

/* eslint-disable */
export const FocusWrapper = styled.div`
  /* true if the wrapped Button has focus */
  &:has(:focus) {
    button {
      background-color: ${({ theme }) =>
    theme?.color?.button?.primary?.background?.hover?.value};
      ${focusOutlinesStyles.primary};
    }
  }
`;
/* eslint-disable */


export const ContentSeparator = styled.div`
  width: 1px;
  background-color: #dfdfdf;
  padding-top: 0.5rem;
`;

export const VariedWidthSection = styled.div<InputWrapperType>`
  width: ${(props: InputWrapperType) => props.width || `100%`};
`;

export const StyledBackButton = styled(IconChevronLeft)`
  fill: black;
`;

export const StyledHeaderTitleWrapper = styled.div`
  display: flex;
`;

export const StyledOrderHeaderButton = styled(Button)`
  margin-left: 8px;
`;

export const StyledWarningButton = styled(Button)`
  margin-left: 8px;
  background-color: #fa9c19 !important;
`;

export const StyledPageHeaderButtonContainer = styled.div`
  display: flex;
  padding: 12px 16px 12px 0;
`;



export const StyledPageHeaderWrapper = styled(PageHeaderWrapper)`
  display: flex;
  margin-bottom: 10px;
  flex-direction: column;
`;




export const StyledButtonContainer = styled.div`
  display: flex;
  padding: 12px 16px 12px 0;
`;

export const StyledButton = styled(Button)`
  margin-left: 8px;
`;

export const StyledOverflowButton = styled(Button)`
  margin-left: 8px;
  padding: 0 0 0 3px;
  min-width: 36px;
`;

export const StyledPanelButtonContainer = styled.div`
  padding: 2%;
  text-align: left;
  margin-top: 2%;
`;